module.exports = __webpack_public_path__ + "static/media/car-front-white.1eef3fff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Allianz/images/car-front-white.svg
// module id = 4033
// module chunks = 0